<template>
  <Field
    :label="label"
    :type="'select'"
    :id="id"
    :name="name"
    :disabled="disabled"
    :readonly="readonly"
    :placeholder="placeholder"
    :validate="validate"
    :validateAs="validateAs"
    :errorText="errorText"
    :helpText="helpText"
    :elementClass="elementClass"
    :labelClass="labelClass"
    :inputClass="inputClass"
    :options="options"
    v-model="input"
  />
</template>

<script>
import InputFieldProps from "mixins/InputFieldProps";
export default {
  mixins: [InputFieldProps],
  props: {
    value: { required: true }
  },
  data() {
    return {
      input: this.value,
      options: [
        { value: "America/New_York", label: "Eastern Time" },
        { value: "America/Chicago", label: "Central Time" },
        { value: "America/Denver", label: "Mountain Time" },
        { value: "America/Los_Angeles", label: "Pacific Time" },
        { value: "America/Anchorage", label: "Alaskan Time" },
        { value: "Pacific/Honolulu", label: "Hawaiian Time" }
      ]
    };
  },
  watch: {
    value(val) {
      this.input = val;
    },
    input(val) {
      this.$emit("input", val);
    }
  },
  mounted() {
    this.input = this.value;
  }
};
</script>